const config = {
  API_URL: "https://movie-api-k8molony.vercel.app/",
};

export default config;
